View = require 'view'
t = require('views/internal/teacup-with-helpers')('request_admin_invite')

template = t.renderable ({ memberInviter }) ->
  t.div '.invitation-link-description.request-admin-invite', ->
    t.h2 ->
      t.format 'lets-add-you-to-this-board-in-another-way'
    t.p '.invitation-link-explanation', ->
      t.format 'has-invited-you-to-this-board', { memberInviterName: memberInviter.fullName }

module.exports = class RequestAdminInviteView extends View
  className: 'invitation-link'
  initialize: ({ @memberInviter }) ->
  render: ->
    @$el.html template({ @memberInviter })
    @




// WEBPACK FOOTER //
// ./app/scripts/views/invitation-link/request-admin-invite-view.coffee